<template>
<div class="about-area">
   <div class="container">
            <!-- Trending Tittle -->
            <div class="row">
               <div class="col-lg-12">
                     <div class="trending-tittle">
                     </div>
               </div>
            </div>
            <div class="row">
               <div class="col-lg-8">
                     <!-- Trending Tittle -->
                           <div class="about-right mb-90">
                                 <div class="section-tittle mb-30 pt-30">
                                    <h3 style="text-align: center;">THÔNG BÁO VỀ VIỆC ĐẤU GIÁ TÀI SẢN</h3>
                                 </div>
                                 <div class="about-prea" style="text-align: justify;">
                                    <p class="about-pera1">Công ty Đấu giá Hợp danh Số 5 – Quốc gia chuẩn bị đưa ra đấu giá tài sản bằng hình thức trực tuyến trên Trang thông tin điện tử đấu giá trực tuyến (địa chỉ: <a href="https://daugiaso5.vn/">https://daugiaso5.vn/</a>) với các nội dung như sau:</p>
                                    <p class="about-pera1">Tài sản đấu giá là Căn hộ số 2130 tại tầng 21 thuộc tòa P06, khu đô thị Gia Lâm (VinCity Ocean Park) thuộc thị trấn Trâu Quỳ, các xã Dương Xá, Kiêu Kỵ, Đa Tốn, huyện Gia Lâm, thành phố Hà Nội theo Hợp đồng mua bán căn hộ số P062130 ngày 05/01/2019 giữa ông Hoàng Hanh Thông và Công ty TNHH đầu tư và phát triển đô thị Gia Lâm. (Vinhomes Ocean Park là dự án Đại đô thị văn minh, hiện đại được quy hoạch theo mô hình sinh thái phong cách Singapore. Với điểm nhấn là hồ điều hòa rộng 24,5ha và biển hồ giữa lòng thành phố, Vinhomes Gia Lâm được ví như một thành phố Đại dương thu nhỏ với hệ thống tiện ích lý tưởng và độc đáo).</p>
                                    <p class="about-pera1">Giá trị căn hộ (đã bao gồm thuế GTGT) theo Hợp đồng mua bán căn hộ nêu trên là: 1.013.612.685 đồng (Một tỷ không trăm mười ba triệu, sáu trăm mười hai nghìn, sáu trăm tám mươi lăm đồng), trong đó, ông Hoàng Hanh Thông đã nộp cho Chủ đầu tư số tiền là: 742.175.920 đồng (tương đương với khoảng 75% giá trị căn hộ).</p>
                                    <p class="about-pera1">Người trúng đấu giá sẽ được chuyển nhượng Hợp đồng mua bán căn hộ nêu trên theo quy định của pháp luật. Thông tin chi tiết về căn hộ cụ thể tại Hồ sơ mời tham gia đấu giá.</p>
                                    <p class="about-pera1">* Giá khởi điểm dự kiến: 750.000.000 đồng (Bằng chữ: bảy trăm năm mươi triệu đồng).</p>
                                    <p class="about-pera1">* Bước giá: <strong>1.000.000 đồng</strong> (Bằng chữ: Một triệu đồng).</p>
                                    <p class="about-pera1">* Thời gian dự kiến tổ chức đấu giá: <strong>Tháng 7 năm 2020.</strong></p>
                                    <p class="about-pera1">* Cách thức đấu giá: <strong>đấu giá tài sản bằng hình thức trực tuyến</strong> trên Trang thông tin điện tử đấu giá trực tuyến (địa chỉ: <a href="https://daugiaso5.vn/">https://daugiaso5.vn/</a>)</p>
                                    <p class="about-pera1">* Chi tiết xin liên hệ: </p>
                                    <p class="about-pera1">- <i>Công ty Đấu giá Hợp danh Số 5 – Quốc gia; ĐT: 024.37.622.619.</i></p>
                                    <p class="about-pera1">- <i>Địa chỉ: Số 193 Hoàng Văn Thái, Khương Trung, Thanh Xuân, thành phố Hà Nội.</i></p>
                                 </div>
                           </div>
               </div>
               <div class="col-lg-4">
               </div>
            </div>
   </div>
</div>
</template>

<script>
import mixin from '@/mixins/mixin.js'
export default {
  name: 'Invates',
  mixins: [mixin],
  data () {
    return {
    }
  },
  methods: {
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Invates/1.vue